import { render, staticRenderFns } from "./BulkEnrollmentUploadModal.vue?vue&type=template&id=6f85208f&scoped=true"
import script from "./BulkEnrollmentUploadModal.vue?vue&type=script&lang=ts"
export * from "./BulkEnrollmentUploadModal.vue?vue&type=script&lang=ts"
import style0 from "./BulkEnrollmentUploadModal.vue?vue&type=style&index=0&id=6f85208f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f85208f",
  null
  
)

export default component.exports